import Vue from "vue";
import store from "@/store/index";

import {
	chat,
	$TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
	eventInstance
} from "./create";

const chatLogin = ({
	userID
})=>{
	if(!userID){
		console.warn("chatLogin: userID 为空");
		return;
	}
	let promise = chat.login({userID});

	promise.then(function(imResponse) {
	  console.log("自研IM登录成功:", userID);
	  $SKD_STATUS.$LOGIN_SUCCESS = true;
	  $SKD_STATUS.$SKD_READY = true;
	  eventInstance.emit("im-login",{
	  		unreadCount: getUnreadCount()
	  });
	  eventInstance.emit("EVENT.LOGIN_SUCCESS",{
		  data: imResponse
	  });
	}).catch(function(imError){
	  console.warn('登录失败login error:', imError);
	});
}

const getUnreadCount = ()=>{

	return chat.getTotalUnreadMessageCount();
}

// 初始化IM实例
const initIMInstance = ()=>{
	let userID = store.state.id;
	if(userID){
		console.log("====已登录");
		chatLogin({userID});
	}
	else{
		eventInstance.on("login-success",()=>{
			let userID = store.state.id;
			chatLogin({userID});
		});
	}
}

// 当用户被踢下线的重新登录
const kickOutIMReLogin = ()=>{
	eventInstance.on("TencentCloudChat.EVENT.KICKED_OUT",()=>{
		// initIMInstance();
	});
}

// IM实例销毁
const	imInstanceDestroy = ()=>{
	if(chat){
		let promise = chat.logout();
		promise.then(function(imResponse) {
			console.log(imResponse.data); // 登出成功
		}).catch(function(imError) {
			console.warn('logout error:', imError);
		});
	}
}

export {
	chat,
	$TencentCloudChat,
	$TencentCloudChatEvent,
	$TencentCloudChatType,
	$SKD_STATUS,
	chatLogin,
	getUnreadCount,
	eventInstance,
	initIMInstance,
	kickOutIMReLogin,
	imInstanceDestroy
}
